const isFileAndSchedule = (fileId: number | null, schedule: any) =>
    fileId !== null && schedule;

const hasPermissionAndLoading = (hasPermission: boolean, isLoading: boolean) =>
    hasPermission && isLoading;

export { isFileAndSchedule, hasPermissionAndLoading };
